import { render, staticRenderFns } from "./zzl-form-ind.vue?vue&type=template&id=65f25613"
import script from "./zzl-form-ind.vue?vue&type=script&lang=js"
export * from "./zzl-form-ind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports